<div class="tags-list-container"  fxLayout="column" fxLayoutGap="15px" fxFlex="100">
  <div fxFlex="100" fxLayout="row">
  <form  (keyup.enter)="filter()" (submit)="filter()"  #filtersForm="ngForm" class="form-apply-list-filters" fxLayout="row" fxFlex="50">
    <ng-container>
      <mat-form-field class="form-list-filter" fxFlex="25">
        <input matInput placeholder="Wyszukiwarka"
               [(ngModel)]="initialFilters.finder" name="finder" >
      </mat-form-field>
      <app-dict
        label="Status" class="form-list-filter"
        dictType="form_row_status"
        [multiple] = "true"
        [(ngModel)]="initialFilters.in$status" name="in$status"
      ></app-dict>

      <app-datepicker
        class="form-list-filter"
        label="Data utworzenia od"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt" ></app-datepicker>

      <app-datepicker
        class="form-list-filter"
        label="Data utworzenia  do"
        placeholder="2000-01-01"
        [required]="false"
        [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
      ></app-datepicker>
    </ng-container>
  </form>
  </div>
  <div fxFlex="100" fxLayout="row">
  <div class="form-apply-list-buttons" fxLayoutAlign="end end" fxFlex="100">
    <button  *ngIf="(userPermissions | async).form.read_report " (click)="downloadReport()" mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button  (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>
  </div>
  <div fxLayout="column" fxFlex="100">
  <table mat-table [dataSource]="items" multiTemplateDataRows>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef> Data zgłoszenia </th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{ element.createdAt | date: 'y-MM-dd H:mm' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Adres email </th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{ getEmail(element) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="partner">
      <th mat-header-cell *matHeaderCellDef> Przypisany partner </th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        <div class="type-display"  >
          <div class="type-field" *ngIf="element.partner">
            <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
          </div>
          <div class="type-field" *ngIf="!element.partner">
            <span> - </span>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        <button mat-raised-button [ngClass]="element.status.color + '-button'">{{element.status.name}}</button>
      </td>
    </ng-container>
    <ng-container matColumnDef="serviceTime">
      <th mat-header-cell *matHeaderCellDef> Czas obsługi</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        <span>{{ calculateTimeDifference(element.serviceTimeEnd) }}</span>
      </td>
    </ng-container>



    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expanded-row-td">
        <div class="expanded-data" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div fxFlex="100" *ngIf="element == expandedElement">
            <app-dynamic-form-view
              [formRow]="element"
              (modifyClicked)="modify = true"
              *ngIf="!modify"
              fxFlex="100"
            ></app-dynamic-form-view>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="(userPermissions | async).form.write" (click)="openModal(element)"  mat-icon-button ><mat-icon>content_copy</mat-icon></button>
        <button *ngIf="(userPermissions | async).form.write " (click)="openStatusModal(element)"  mat-icon-button ><mat-icon>autorenew</mat-icon></button>

        <button *ngIf="(userPermissions | async).form.delete" [disabled]="!(userPermissions | async)?.form.delete" color="warn" mat-icon-button (click)="delete(element)"><mat-icon>delete</mat-icon></button>
        <button *ngIf="element !== expandedElement"  (click)="expandElement(element)"  color="accent" mat-icon-button ><mat-icon>keyboard_arrow_down</mat-icon></button>
        <button *ngIf="element == expandedElement"  (click)="expandElement(element)"  color="accent" mat-icon-button ><mat-icon>keyboard_arrow_up</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      class="table-row"
      mat-row *matRowDef="let element; let row; columns: displayedColumns;"
      [class.expanded-row]="expandedElement === element"
      [class.not-expanded-row]="expandedElement && expandedElement !== element"
      [ngClass]="{'overvoltage': element.overvoltage}"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" [ngClass]="{'overvoltageDisable': row.overvoltage}" class="expanded-data-row"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
</div>
